import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rmSlash'
})
export class RmSlashPipe implements PipeTransform {

  transform(content: string | null | undefined): string | null {
    if (!content) return null;

    let result = '';
    for (let i = 0; i < content.length; i++) {
      if (content[i] === '/' && (i === 0 || content[i - 1] !== '<')) {
        // result += ''; // 추가하지 않는다.
      } else {
        result += content[i];
      }
    }
    return result;
  }
}
